import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { DateRange, Statistics, makeStatistics } from '../models';

@Injectable()
export class SmsService {
  constructor(
    private readonly http: HttpClient,
    @Inject('smsBaseUrl') private smsBaseUrl: string,
  ) {}

  private getApiUrl(path: string, accountId: string) {
    return `${this.smsBaseUrl}dataprovider/statistics/v1/${path}${
      accountId ? 'PerAccount' : ''
    }`;
  }

  private getParams({ from, to }: DateRange, accountId: string) {
    return {
      startDate: from.toString(),
      endDate: to.toString(),
      ...(accountId && { accountId }),
    };
  }

  getStatisticsOverview(dateRange: DateRange, accountId: string) {
    return this.http
      .get(this.getApiUrl('GetStatisticsOverview', accountId), {
        params: this.getParams(dateRange, accountId),
      })
      .pipe(map((statistics: Statistics) => makeStatistics(statistics)));
  }

  getCountryCodes(dateRange: DateRange, accountId: string) {
    return this.http.get<Statistics[]>(
      this.getApiUrl('GetCountryCodes', accountId),
      {
        params: this.getParams(dateRange, accountId),
      },
    );
  }

  getTotalTimeline(timeSlices: number[], accountId: string) {
    return this.http.post<Statistics[]>(
      this.getApiUrl('GetTotalTimeline', accountId),
      timeSlices,
      { params: accountId && { accountId } },
    );
  }
}
